import services from '../../../../services';
import * as types from './action-types';
import _ from 'lodash';
import { getSimpleOffers } from '../util';

const FAILED_MESSAGE = 'Failed to succeed';

const api = services.coreAPIInstance;
const UserService = services.UserService;

const selectOffer = (offerId) => ({
    asyncAction: (dispatch, getState) => {
        const deviceFingerprint = localStorage.getItem('blackboxId') || ';';
        return api.offers.select({ offerId, deviceFingerprint }).then((res) => {
            const { data } = res;
            UserService.set(
                { ...data.user, employmentStatus: data.employmentStatus, leadSource: data.leadSource }
            );
            window.dataLayer.push({
                event: 'LOAN_OFFER_SELECTED',
                loanId: data.user.loanId,
                underwritingCard: data.cardId,
            });
            return res;
        });
    },
    type: types.OFFER_SELECTING,
});

const selectOfferAuthenticated = (offerId, loanId) => ({
    asyncAction: (dispatch, getState) => {
        return api.offers.selectAuthenticated({ offerId,  loanId}).then((response) => {
            window.dataLayer.push({
                event: 'LOAN_OFFER_SELECTED',
                loanId,
            });
            const convertedResponse = getSimpleOffers(response);
            const result = { data: { offer: convertedResponse.selectedOffer } }
            if (typeof angular !== 'undefined') {
                const injector = angular.element(document.querySelector('body')).injector();

                const loanService = injector.get("loan");
                if (loanService) {
                    return new Promise((resolve, reject) => {
                        // get the angular side if things in sync
                        loanService.refreshCurrentLoanFromDB().then(
                            function (loan) {
                                const nextStep = loanService.getNextStep();
                                injector.get("$state").go(nextStep);
                                resolve();
                            },
                            function (error) {
                                reject(error);
                            }
                        );
                    });
                }
            }
            return result;
        });
    },
    type: types.OFFER_SELECTING,
});

export default {
    FAILED_MESSAGE,
    selectOffer,
    selectOfferAuthenticated,
};
